module.exports = __webpack_public_path__ + "static/application-mobile.4a728cf1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/img/application-mobile.jpg
// module id = 834
// module chunks = 207607843663661